import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";

import { Link, useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "components/Breadcrumb";

import useUnityViewer from "hooks/useUnityViewer";
import { useWorkspaces } from "contexts/WorkspacesContext";
import { useGetProjectQuery } from "api/project/queries/useGetProjectQuery";
import { Icon } from "@iconify/react";
import ExistingReferenceMeasurements from "containers/VirtualTourViewer/ExistingReferenceMeasurements";
import { truncateText } from "utils/misc";

interface VTHeaderProps {
  headingName: string;
  scanName: string;
}

const VirtualTourHeader = ({
  headingName,
  scanName,
}: VTHeaderProps) => {
  const navigate = useNavigate();
  const { projectSlug = "", scanId = "", workspaceSlug } = useParams();
  const { activeWorkspace } = useWorkspaces();
  const theme = useTheme();
  const {
    data: project,
    isLoading: isProjectLoading,
    error: projectError,
  } = useGetProjectQuery(projectSlug, workspaceSlug);

  const { unityViewerContext } = useUnityViewer();

  const unloadUnityViewer = async () => {
    await unityViewerContext?.unload;
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLaptop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack
      sx={{
        marginBottom: "1rem",
        flexDirection: {
          xs: "column",
          md: "row"
        },
        alignItems: {
          xs: "flex-start",
          md: "center"
        },
        justifyContent: {
          xs: "flex-start",
          md: "space-between"
        }
      }}
    >
      <Stack spacing={1}>
        <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"}>
          <Box onClick={async () => {
            await unloadUnityViewer();
            navigate("../../..", { relative: "path" });
          }}>
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                cursor: "pointer",
                ":hover": {
                  color: "white"
                }
              }}
            >{isLaptop ? activeWorkspace.name : truncateText(activeWorkspace.name, isMobile ? 10 : 20)}
            </Typography>
          </Box>
          <Icon icon={"icon-park-outline:right"} color="#aaa" />
          <Box onClick={async () => {
            await unloadUnityViewer();
            navigate("../..", { relative: "path" });
          }}>
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                cursor: "pointer",
                ":hover": {
                  color: "white"
                }
              }}
            >{isLaptop ? project?.name : truncateText(project?.name || "", isMobile ? 10 : 20)}
            </Typography>
          </Box>
          <Icon icon={"icon-park-outline:right"} color="#aaa" />
          <Box onClick={async () => {
            await unloadUnityViewer();
            navigate("..", { relative: "path" });
          }}>
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                cursor: "pointer",
                ":hover": {
                  color: "white"
                }
              }}
            >{isLaptop ? scanName : truncateText(scanName, isMobile ? 10 : 20)}
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title="Back" placement="right">
            <IconButton
              onClick={async () => {
                await unloadUnityViewer();
                navigate("..", { relative: "path" });
              }}
            >
              <ArrowBackIcon sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Tooltip>
          <Typography variant={isMobile ? "h2" : "h1"} sx={{ fontWeight: "600" }}>{headingName}</Typography>
        </Stack>
      </Stack>
      {/* {!type && (
        <Breadcrumb name1={name1 ?? "Project"} name2={name2 ?? "Scan"} />
      )} */}
      {/* {output.virtualTour && !output.virtualTour.isScaled && (
        <ExistingReferenceMeasurements
          isPublic={isPublic}
          referenceMeasurements={referenceMeasurements}
          virtualTourID={output?.virtualTour?.id || ""}
        />
      )} */}
    </Stack>
  );
};

export default VirtualTourHeader;
